// extracted by mini-css-extract-plugin
export var inline = "_vv-0";